var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sq-player-wrap",style:({width:_vm.width,height:_vm.height})},[_c('div',{ref:_vm.playerName,class:{'kplayer': _vm.playerClass,'aplayer': !_vm.playerClass, 'video-center': _vm.isVideoCenter }})])
}
var staticRenderFns = []

export { render, staticRenderFns }